import gql from "graphql-tag";

// Fires when the modal opens, not on completion; on_conflict with no update columns makes a
// double fire a no-op. userId/tenantId are stamped by Hasura presets, never sent from the client.
const InsertUserWelcomeFlowMutation = gql`
  mutation InsertUserWelcomeFlow($flowKey: String!, $variant: String!) {
    insert_userWelcomeFlow_one(
      object: { flowKey: $flowKey, variant: $variant }
      on_conflict: { constraint: user_welcome_flow_pkey, update_columns: [] }
    ) {
      userId
      flowKey
    }
  }
`;

export default InsertUserWelcomeFlowMutation;
